module.exports = __webpack_public_path__ + "img/4.0cb41cc4.jpeg";